import React, { useState, useContext, useEffect } from "react";
import { CustomElementsContext } from "../../../context/CustomElementsContext";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import Popup from "../../Modal/Popup";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import cloneDeep from "lodash.clonedeep";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import * as UTILS from "../../../utils/Utils";
import Counter from "../../Tool/Counter/Counter";
import classnames from "classnames";
import LinkOption from "../../Tool/LinkOption/LinkOption";
import "./Modal.scss";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import { track } from "@amplitude/analytics-browser";

const CustomModal = (props) => {
  const [state, setState] = useState({
    activeTabModal: "1",
  });
  const { customButtons, setCustomButtons } = useContext(CustomElementsContext);
  useEffect(() => {}, [customButtons, props.element]);

  const toggleModalTabl = (tab) => {
    if (state.activeTabModal !== tab) {
      setState({
        activeTabModal: tab,
      });
    }
  };
  const resetMarginLeftRight = () => {
    const layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style.marginLeft = "0";
        item.style.marginRight = "0";
      },
      (colItem) => {
        colItem.style.marginLeft = "0";
        colItem.style.marginRight = "0";
      },
      (colItemNested) => {
        colItemNested.style.marginLeft = "0";
        colItemNested.style.marginRight = "0";
      }
    );

    props.layoutArray(props.layoutTitle, newLayout);
  };
  const counterChange = (e, property) => {
    const layout = cloneDeep(props.layout);

    var selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    if (
      property == "paddingBottom" ||
      property == "paddingLeft" ||
      property == "paddingRight" ||
      property == "paddingTop" ||
      property == "marginBottom" ||
      property == "marginLeft" ||
      property == "marginRight" ||
      property == "marginTop"
    ) {
      selectedValue > 200
        ? (selectedValue = 200)
        : (selectedValue = selectedValue);
    }

    if (property == "borderWidth") {
      selectedValue > 50
        ? (selectedValue = 50)
        : (selectedValue = selectedValue);
    }
    if (property == "borderRadius") {
      selectedValue > 1000
        ? (selectedValue = 1000)
        : (selectedValue = selectedValue);
    }

    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );

    props.layoutArray(props.layoutTitle, newLayout);
  };
  const counterPlus = (value, property) => {
    const layout = cloneDeep(props.layout);
    var selectedValue = value;

     if (
      ( property == "paddingBottom" ||
       property == "paddingLeft" ||
       property == "paddingRight" ||
       property == "paddingTop" ||
       property == "marginBottom" ||
       property == "marginLeft" ||
       property == "marginRight" ||
       property == "marginTop" )& (selectedValue >= 200)
     ) {
       return;
     }

     if ((property == "borderWidth") & (selectedValue >= 50)) {
       return;
     }
     if ((property == "borderRadius") & (selectedValue >= 1000)) {
       return;
     }
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const counterMinus = (value, property) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const unitValueChange = (e, property) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  // BORDER RADIUS
  const borderRadiusToggle = (e) => {
    if (e.target.checked == true) {
      setState({
        borderRadiusControl: true,
      });
    } else {
      setState({
        borderRadiusControl: false,
      });
    }
  };

  const buttonSetting = (e, property) => {
    const layout = cloneDeep(props.layout);
    var selectedValue = e.target.value;
    if ((property == "fontSize") & (selectedValue > 200)) {
      selectedValue = 200;
    }

    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const mobileAlignment = (e, property) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item[property] = selectedValue;
      },
      (colItem) => {
        colItem[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested[property] = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  //BUTTON LABEL
  const addLabelButton = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.content = selectedValue;
      },
      (colItem) => {
        colItem.content = selectedValue;
      },
      (colItemNested) => {
        colItemNested.content = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const addButtonName = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };
  // Button Normal
  const colorPickerDisplay = (keyVal, property) => {
    setState({
      [keyVal]: property,
    });
  };

  // Button Border

  // BTN COLOR PICKER FUNCTIONS
  const buttonColorSetting = (color, key, property) => {
    const layout = cloneDeep(props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item[key][property].rgb = color;
      },
      (colItem) => {
        colItem[key][property].rgb = color;
      },
      (colItemNested) => {
        colItemNested[key][property].rgb = color;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  // BTN HOVER COLOR PICKER FUNCTIONS
  const widthToggle = (e, property) => {
    const layout = cloneDeep(props.layout);
    e.target.checked && resetMarginLeftRight;
    const fullWidth = e.target.checked ? "100%" : "auto";
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style[property] = fullWidth;
        item.style.marginLeft = "0";
        item.style.marginRight = "0";
      },
      (colItem) => {
        colItem.style[property] = fullWidth;
        colItem.style.marginLeft = "0";
        colItem.style.marginRight = "0";
      },
      (colItemNested) => {
        colItemNested.style[property] = fullWidth;
        colItemNested.style.marginLeft = "0";
        colItemNested.style.marginRight = "0";
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };
  const fontWeight = (e) => {
    const layout = cloneDeep(props.layout);

    const fontWeight = e.target.checked ? "bold" : "normal";
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.style.fontWeight = fontWeight;
      },
      (colItem) => {
        colItem.style.fontWeight = fontWeight;
      },
      (colItemNested) => {
        colItemNested.style.fontWeight = fontWeight;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const onStart = () => {
    setState({ activeDrags: ++state.activeDrags });
  };

  const onStop = () => {
    setState({ activeDrags: --state.activeDrags });
  };
  const setCustomButtonStyle = (e) => {
    const layout = cloneDeep(props.layout);
    var button = customButtons.filter(
      (button) => button.custom_element_name === e.target.value
    );
    button[0] == undefined
      ? (button = { ...UTILS.tool[2] })
      : (button = button[0].custom_element_json);

    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        (item.style = button.style),
          (item.mobileAlignment = button.mobileAlignment),
          (item.customElementName = button.customElementName),
          (item.normalBtn = button.normalBtn),
          (item.hoverBtn = button.hoverBtn);
      },
      (colItem) => {
        (colItem.style = button.style),
          (colItem.mobileAlignment = button.mobileAlignment),
          (colItem.customElementName = button.customElementName),
          (colItem.normalBtn = button.normalBtn),
          (colItem.hoverBtn = button.hoverBtn);
      },
      (colItemNested) => {
        (colItemNested.style = button.style),
          (colItemNested.mobileAlignment = button.mobileAlignment),
          (colItemNested.customElementName = button.customElementName),
          (colItemNested.normalBtn = button.normalBtn),
          (colItemNested.hoverBtn = button.hoverBtn);
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
       track("GlobalStyleApplied", {
         styleName: button.custom_element_name,
         buttonID: button.customElementID,
       });
  };

  const fullwidth = props.fullWidth == "100%" ? true : false;

  const dragHandlers = { onStart: onStart, onStop: onStop };
  const buttonFont = (
    <select
      style={{}}
      // className="selectFontFamily"
      type="text"
      placeholder="Select Font Family"
      value={
        props.fontName ? props.fontName : props.selectedFont
      }
      onChange={(e) => {
        buttonSetting(e, "fontFamily");
      }}
    >
  
      {props.googleFonts.map((font) => (
        <option key={font.format} value={font.format}>
          {font.name}
        </option>
      ))}
    </select>
  );
  const buttonFontSize = (
    <div className="">
      <input
        type="text"
        value={props.fontSize > 200 ? 200 : props.fontSize < 0? 0 : props.fontSize}
        onChange={(e) => {
          buttonSetting(e, "fontSize");
        }}
      />
    </div>
  );
  const buttonAlignment = (
    <select
      value={props.floatVal}
      onChange={(e) => {
        buttonSetting(e, "float");
      }}
    >
      <option value="left">Left</option>
      <option value="none">Center</option>
      <option value="right">Right</option>
    </select>
  );
  const buttonAlignmentMobile = (
    <select
      value={props.mobileAlignment}
      onChange={(e) => {
        mobileAlignment(e, "mobileAlignment");
      }}
    >
      <option defaultChecked value="left">
        Left
      </option>
      <option value="none">Center</option>
      <option value="right">Right</option>
    </select>
  );


  const shouldHaveAsterisk = () => {
    var button = customButtons.filter((button) => {
      return (
        JSON.stringify(button.custom_element_name) ==
        JSON.stringify(props.element.customElementName)
      );
    });
    button =
      button[0] == undefined
        ? { custom_element_json: UTILS.tool[2] }
        : button[0];
    if (
      JSON.stringify(button.custom_element_json.style) !=
        JSON.stringify(props.element.style) ||
      JSON.stringify(button.custom_element_json.hoverBtn) !=
        JSON.stringify(props.element.hoverBtn) ||
      JSON.stringify(button.custom_element_json.normalBtn) !=
        JSON.stringify(props.element.normalBtn) ||
      JSON.stringify(button.custom_element_json.mobileAlignment) !=
        JSON.stringify(props.element.mobileAlignment)
    ) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <Popup
      width="700"
      header="Button Settings"
      closePopup={props.closePopup}
      close={props.closePopup}
    >
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "1",
            })}
            onClick={() => {
              toggleModalTabl("1");
            }}
          >
            General
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "2",
            })}
            onClick={() => {
              toggleModalTabl("2");
            }}
          >
            Normal
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "3",
            })}
            onClick={() => {
              toggleModalTabl("3");
            }}
          >
            Hover
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: state.activeTabModal === "4",
            })}
            onClick={() => {
              toggleModalTabl("4");
            }}
          >
            Link
          </NavLink>
        </NavItem>
      </Nav>
      <div className="modalScrollContainer">
        <TabContent
          className="buttonSettingWrapper"
          activeTab={state.activeTabModal}
        >
          <TabPane tabId="1" className="general-tab">
            <div className="general-setting">
              <div className="">
                <div className="modalContentWrapper">
                  <label>
                    Label <small>(For Meta Data and Aria Labels)</small>
                  </label>
                  <input
                    style={{
                      paddingLeft: "5px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                    onChange={addButtonName}
                    defaultValue={props.label}
                    placeholder="Add Button Label"
                    className="textInput"
                    type="text"
                  />
                  <label>Text Content</label>
                  <input
                    style={{
                      paddingLeft: "5px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                    onChange={addLabelButton}
                    defaultValue={props.content}
                    placeholder="Add Button Text Content"
                    className="textInput"
                    type="text"
                  />
                  <label>Custom Button Name</label>
                  <select
                    style={{
                      paddingLeft: "5px",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                    value={props.element.customElementName}
                    onChange={setCustomButtonStyle}
                    className="textInput"
                  >
                    <option value="none"> None</option>
                   // Replace this part in the render method
                    {customButtons &&
                      customButtons.map((button, index) => {
                        const hasAsterisk = button.custom_element_name === props.element.customElementName && shouldHaveAsterisk();
                        return (
                          <option
                            key={button.custom_element_id || `button-${index}`}
                            value={button.custom_element_name}
                          >
                            {button.custom_element_name + (hasAsterisk ? " *" : "")}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="wrap">
                  <div
                    className="padding-section"
                    style={{ marginBottom: "10px", marginTop: "20px" }}
                  >
                    <div className="heading">Font Settings</div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="modalContentWrapper"
                  >
                    <div className="modalSetting">
                      <label>Font Family</label>
                      {buttonFont}
                    </div>
                    <div className="modalSetting">
                      <label>
                        Font Size <small>(Pixels)</small>
                      </label>
                      {buttonFontSize}
                    </div>
                    <div className="modalSetting">
                      <label>Font Bold</label>

                      <input
                        type="checkbox"
                        id="font_weight"
                        name="fontWeight"
                        onChange={fontWeight}
                        checked={props.fontWeight === "bold" ? true : false}
                      />
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="">
                  <div
                    className="padding-section"
                    style={{ marginBottom: "10px", marginTop: "20px" }}
                  >
                    <div className="heading">Width and Alignment</div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="modalContentWrapper"
                  >
                    <div className="modalSetting">
                      <label>Button Align for desktop</label>
                      {buttonAlignment}
                    </div>

                    <div className="modalSetting">
                      <label>Button Align for mobile</label>
                      {buttonAlignmentMobile}
                    </div>

                    <div className="modalSetting">
                      <label>100% Width</label>

                      <input
                        type="checkbox"
                        style={{ display: "block" }}
                        // value="percentage"
                        onChange={(e) => {
                          widthToggle(e, "width");
                        }}
                        checked={fullwidth}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="padding-section">
                <div
                  className="padding-section"
                  style={{ marginBottom: "5px" }}
                >
                  <div className="heading">Padding </div>
                </div>

                <div
                  className="heading-row modalContentWrapper"
                  style={{ justifyContent: "flex-end" }}
                >
                  <UnitSelector
                    value={props.btnPaddingUnit ? props.btnPaddingUnit : "px"}
                    onChange={(e) => {
                      unitValueChange(e, "btnPaddingUnit");
                    }}
                  />
                </div>

                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div className="d-block">
                    <Counter
                      label="Top"
                      small={props.btnPaddingUnit === "%" ? "percent" : "pixel"}
                      minusClick={() =>
                        counterMinus(props.paddingTop, "paddingTop")
                      }
                      valueContent={props.paddingTop}
                      disabled={false}
                      onChange={(e) => {
                        counterChange(e, "paddingTop");
                      }}
                      plusClick={() => {
                        counterPlus(props.paddingTop, "paddingTop");
                      }}
                    />{" "}
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Bottom"
                      small={props.btnPaddingUnit === "%" ? "percent" : "pixel"}
                      minusClick={() =>
                        counterMinus(props.paddingBottom, "paddingBottom")
                      }
                      valueContent={props.paddingBottom}
                      disabled={false}
                      onChange={(e) => {
                        counterChange(e, "paddingBottom");
                      }}
                      plusClick={() =>
                        counterPlus(props.paddingBottom, "paddingBottom")
                      }
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Left"
                      small={props.btnPaddingUnit === "%" ? "percent" : "pixel"}
                      minusClick={() =>
                        counterMinus(props.paddingLeft, "paddingLeft")
                      }
                      valueContent={props.paddingLeft}
                      disabled={false}
                      onChange={(e) => {
                        counterChange(e, "paddingLeft");
                      }}
                      plusClick={() =>
                        counterPlus(props.paddingLeft, "paddingLeft")
                      }
                    />
                  </div>
                  <div className="d-block">
                    <Counter
                      label="Right"
                      small={props.btnPaddingUnit === "%" ? "percent" : "pixel"}
                      minusClick={() =>
                        counterMinus(props.paddingRight, "paddingRight")
                      }
                      valueContent={props.paddingRight}
                      disabled={false}
                      onChange={(e) => {
                        counterChange(e, "paddingRight");
                      }}
                      plusClick={() =>
                        counterPlus(props.paddingRight, "paddingRight")
                      }
                    />
                  </div>
                </div>

                <div className="clear" />
              </div>

              <div className="heading-row">
                <div
                  className="padding-section"
                  style={{ marginBottom: "5px" }}
                >
                  <div className="heading">Margin </div>
                </div>
              </div>
              <div
                className="heading-row modalContentWrapper"
                style={{ justifyContent: "flex-end" }}
              >
                <UnitSelector
                  value={props.btnMarginUnit ? props.btnMarginUnit : "px"}
                  onChange={(e) => {
                    unitValueChange(e, "btnMarginUnit");
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
                className="modalContentWrapper"
              >
                <div className="d-block">
                  <Counter
                    label="Top"
                    small={props.btnMarginUnit === "%" ? "percent" : "pixel"}
                    minusClick={() =>
                      counterMinus(
                        props.marginTop ? props.marginTop : 0,
                        "marginTop"
                      )
                    }
                    valueContent={props.marginTop || 0}
                    disabled={false}
                    onChange={(e) => {
                      counterChange(e, "marginTop");
                    }}
                    plusClick={() => {
                      counterPlus(
                        props.marginTop ? props.marginTop : 0,
                        "marginTop"
                      );
                    }}
                  />
                </div>

                <div className="d-block">
                  <Counter
                    label="Bottom"
                    small={props.btnMarginUnit === "%" ? "percent" : "pixel"}
                    minusClick={() =>
                      counterMinus(
                        props.marginBottom ? props.marginBottom : 0,
                        "marginBottom"
                      )
                    }
                    valueContent={props.marginBottom || 0}
                    disabled={false}
                    onChange={(e) => {
                      counterChange(e, "marginBottom");
                    }}
                    plusClick={() =>
                      counterPlus(
                        props.marginBottom ? props.marginBottom : 0,
                        "marginBottom"
                      )
                    }
                  />
                </div>
                <div className="d-block">
                  <Counter
                    label="Left"
                    small={props.btnMarginUnit === "%" ? "percent" : "pixel"}
                    minusClick={() =>
                      counterMinus(
                        props.marginLeft ? props.marginLeft : 0,
                        "marginLeft"
                      )
                    }
                    valueContent={props.marginLeft || 0}
                    disabled={props.fullWidth === "100%"}
                    onChange={(e) => {
                      counterChange(e, "marginLeft");
                    }}
                    plusClick={() =>
                      counterPlus(
                        props.marginLeft ? props.marginLeft : 0,
                        "marginLeft"
                      )
                    }
                  />
                </div>
                <div className="d-block">
                  <Counter
                    label="Right"
                    small={props.btnMarginUnit === "%" ? "percent" : "pixel"}
                    minusClick={() =>
                      counterMinus(
                        props.marginRight ? props.marginRight : 0,
                        "marginRight"
                      )
                    }
                    valueContent={props.marginRight || 0}
                    disabled={props.fullWidth === "100%"}
                    onChange={(e) => {
                      counterChange(e, "marginRight");
                    }}
                    plusClick={() =>
                      counterPlus(
                        props.marginRight ? props.marginRight : 0,
                        "marginRight"
                      )
                    }
                  />
                </div>
              </div>

              <div className="padding-section">
                <div className="heading">Border</div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "50%",
                    }}
                  >
                    <div className="d-block">
                      <Counter
                        label="Border Width"
                        minusClick={() =>
                          counterMinus(props.border, "borderWidth")
                        }
                        valueContent={props.border}
                        disabled={false}
                        onChange={(e) => {
                          counterChange(e, "borderWidth");
                        }}
                        plusClick={() =>
                          counterPlus(props.border, "borderWidth")
                        }
                      />
                    </div>

                    <div className="d-block">
                      <Counter
                        label="Border Radius"
                        minusClick={() =>
                          counterMinus(props.borderRadius, "borderRadius")
                        }
                        valueContent={props.borderRadius}
                        disabled={false}
                        onChange={(e) => {
                          counterChange(e, "borderRadius");
                        }}
                        plusClick={() =>
                          counterPlus(props.borderRadius, "borderRadius")
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="clear" />
              </div>

              <div className="clear" />
            </div>
          </TabPane>
          <TabPane tabId="2" className="normal-tab">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
              className="modalContentWrapper"
            >
              <div style={{ width: "300px", marginRight: "20px" }}>
                <ColorPicker
                  btnLabel=" Text Color"
                  colorValue={props.normalTextColor}
                  colorDefaultValue={props.normalTextColor}
                  getColor={(e) => {
                    buttonColorSetting(e.rgb, "normalBtn", "txtColor");
                  }}
                />
              </div>

              <div style={{ width: "300px" }}>
                {" "}
                <ColorPicker
                  btnLabel=" Background Color"
                  colorValue={props.normalBtnBg}
                  colorDefaultValue={props.normalBtnBg}
                  getColor={(e) => {
                    buttonColorSetting(e.rgb, "normalBtn", "btnBG");
                  }}
                />
              </div>

              <div style={{ width: "300px" }}>
                {" "}
                <ColorPicker
                  btnLabel=" Border Color"
                  colorValue={props.normalBtnBorder}
                  colorDefaultValue={props.normalBtnBorder}
                  getColor={(e) => {
                    buttonColorSetting(e.rgb, "normalBtn", "btnBorder");
                  }}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tabId="3" className="hover-tab">
            <div className="modalContentWrapper">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Text Color"
                    colorValue={props.hoverBtnTextColor}
                    colorDefaultValue={props.hoverBtnTextColor}
                    getColor={(e) => {
                      buttonColorSetting(e.rgb, "hoverBtn", "txtColor");
                    }}
                  />
                </div>

                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Background Color"
                    colorValue={props.hoverBtnBgColor}
                    colorDefaultValue={props.hoverBtnBgColor}
                    getColor={(e) => {
                      buttonColorSetting(e.rgb, "hoverBtn", "btnBg");
                    }}
                  />
                </div>

                <div style={{ width: "300px", marginRight: "20px" }}>
                  {" "}
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={props.hoverBorder}
                    colorDefaultValue={props.hoverBorder}
                    getColor={(e) => {
                      buttonColorSetting(e.rgb, "hoverBtn", "btnBorder");
                    }}
                  />
                </div>
              </div>
            </div>
          </TabPane>
          <TabPane tabId="4" className="hover-tab">
            <LinkOption
              pagesList={props.pagesList}
              ID={props.ID}
              Link={props.Link}
              closePopup={props.closePopup}
              LinkName={props.LinkName}
              LinkType={props.LinkType}
              LinkOpen={props.LinkOpen}
              UseSocial={props.UseSocial}
              layout={props.layout}
            />
          </TabPane>
        </TabContent>
      </div>
    </Popup>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);
